import { Component, Input, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientModel } from '../../../shared/models/client.model';
import { AddressModel } from '../../../shared/models/address.model';
import { OauthService } from '../../../shared/services/oauth.service';
import { CommonHttpService } from '../../../shared/services/http.service';
import { Response } from '@angular/http';
import { OverlayContext } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';

@Component({
    selector: 'account-profile-addresses',
    templateUrl: './account.profile.addresses.component.html',
    styleUrls: [],
    encapsulation: ViewEncapsulation.None
})
export class AccountProfileAddressesComponent {
    @Input('client') client: ClientModel;
    @ViewChild('templateRef') public templateRef: TemplateRef<any>;

    public addresses: Array<AddressModel> = [];
    protected overlayContext = new OverlayContext();

    constructor(
        protected http: CommonHttpService,
        protected oauthService: OauthService,
        protected route: ActivatedRoute,
        protected router: Router,
        protected modal: Modal
    ) {
        this.overlayContext.inElement = false;
        this.overlayContext.isBlocking = true;
        this.overlayContext.keyboard = null;

        this.oauthService.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.indexAddresses();
        });
    }

    public pushNewAddress() {
        this.addresses.unshift(new AddressModel());
    }

    public shiftNewAddress(adding) {
        if (adding) {
            this.addresses.shift();
        }
    }

    public indexAddresses() {
        this.http
            .useAuth()
            .get(`/account/clients/${this.client.id}/addresses?_sort=-updated_at&_limit=5`)
            .subscribe((response: Response) => {
                this.addresses = response.json().data;
            });
    }

    /**
     * Reindex the addresses list after a create/update and, when the
     * `account-subscription-update-address` store configuration is
     * enabled, warn the client that this change is not applied to their
     * subscriptions automatically.
     **/
    public onAddressSaved() {
        this.indexAddresses();

        if (this.showUpdateSubscriptionAlert()) {
            this.modal.open(this.templateRef, {context: this.overlayContext});
        }
    }

    /**
     * Same check used at account.subscriptions.details.component.ts to
     * gate the manual "update subscription address" action.
     **/
    public showUpdateSubscriptionAlert(): boolean {
        const configs = this.route.snapshot.data.storeConfigurations;

        return configs !== undefined
            && configs['account-subscription-update-address'] !== undefined
            && configs['account-subscription-update-address'] !== null;
    }

    public closeDialog(dialogRef: any) {
        dialogRef.close();
    }

    public goToSubscriptions(dialogRef: any) {
        this.closeDialog(dialogRef);
        this.router.navigate(['/account/subscriptions']);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/account/profile/addresses/account.profile.addresses.component.ts